/* components/patterns/notifications/InboxRow.jsx — строка инбокса (S11).
   Пропсы: notification, onMarkRead(id), onToggleRead(id), onDelete(id),
   onOpen(notification), showWorkspace (контекст пространства — фикс №10).
   Класс inbox-row--unread → синяя точка + полужирный заголовок.
   На xs → карточный вид (вертикаль) через CSS. Вся строка кликабельна.
   ХЕНДОФФ: → frontend/src/components/notifications/InboxRow.jsx. */

import { Icon } from '../../ui/Icon.jsx';
import { notifMetaFor as metaFor } from '../../../hooks/useNotificationsStore.jsx';
import { fmt } from '../../../lib/format.js';

  function InboxRow({ notification: n, onToggleRead, onDelete, onOpen, showWorkspace }) {
    const meta = metaFor(n.type);
    const unread = !n.is_read;
    const dest = n.data && n.data.destination;

    return (
      <div className={'inbox-row' + (unread ? ' inbox-row--unread' : '')}>
        <button type="button" className="inbox-row__open"
                onClick={() => onOpen && onOpen(n)}>
          <span className="inbox-row__dot" aria-hidden="true" />
          <span className={'inbox-row__icon inbox-row__icon--' + meta.tone}>
            <Icon name={meta.icon} size={18} />
          </span>

          <span className="inbox-row__main">
            <span className="inbox-row__head">
              <span className="inbox-row__title">{n.title}</span>
              <time className="inbox-row__time num" dateTime={n.created_at}>{fmt.relativeDay(n.created_at)}</time>
            </span>
            {n.body && <span className="inbox-row__body">{n.body}</span>}
            <span className="inbox-row__meta">
              <span className={'notif-tag notif-tag--' + meta.tone}>{meta.label}</span>
              {showWorkspace && n.workspace_name && (
                <span className="inbox-row__ws"><Icon name="building" size={12} />{n.workspace_name}</span>
              )}
              {dest && <span className="inbox-row__dest text-mute"><Icon name="arrow-up-right" size={12} />Перейти</span>}
            </span>
          </span>
        </button>

        <div className="inbox-row__actions">
          <button type="button" className="inbox-row__act"
                  title={unread ? 'Отметить прочитанным' : 'Отметить непрочитанным'}
                  aria-label={unread ? 'Отметить прочитанным' : 'Отметить непрочитанным'}
                  onClick={() => onToggleRead && onToggleRead(n.id)}>
            <Icon name={unread ? 'check' : 'circle'} size={16} />
          </button>
          {onDelete && (
            <button type="button" className="inbox-row__act"
                    title="Удалить" aria-label="Удалить"
                    onClick={() => onDelete(n.id)}>
              <Icon name="trash" size={16} />
            </button>
          )}
        </div>
      </div>
    );
  }

export { InboxRow };
